export default __webpack_public_path__ + "static/media/XRP.a4b3ccdb.svg";